import React from "react";
import Column from "../../../../DataTable/models/Column";
import SiteRow from "../models/SiteRow";
import { LinkText } from "../../../../Common/hyperlinks";
import { SiteUrls } from "../../../../../views/SiteManagement";
import { getUserId, isBRCGSUser, isCBUser } from "../../../../../Authentication/Auth";
import useMegatron from "../../../../../hooks/useMegatron";

const SiteColumnTable = () :Column<SiteRow>[] => {
  const {isMegatronFeaturedOn, isLoading} = useMegatron();

  const brcgsUser = getUserId() != undefined && isBRCGSUser() && isMegatronFeaturedOn;
  const cbUser = getUserId() != undefined && isCBUser() && isMegatronFeaturedOn;

  const siteColumns: Column<SiteRow>[] = [
  {
    title: "Site Code",
    field: "siteCode",
  },
  {
    title: "Site",
    field: "siteName",
    render: (rowData: SiteRow) => (
      <LinkText
        link={SiteUrls.details(rowData.siteCode)}
        text={rowData.siteName}
      />
    ),
  },
  {
    title: "Country",
    field: "country",
    filtering: true,
  },
  {
    title: "City",
    field: "city",
  },
  {
    title: "Owning Company",
    field: "owningCompany",
    filtering: true,
  },
  {
    title: "Status",
    field: "status",
    sorting: true,
  },

  {
    title: "Shared (Y/N)",
    field: "shared",
    sorting: false,
  },
];

  const additionalSiteColumns: Column<SiteRow>[] = [
    {
      title: "Record Status",
      field: "recordStatus",
      sorting: true,
    },
    {
      title: "Audit Start Date",
      field: "auditStart",
      type: "date",
    },
    {
      title: "Expiry Date",
      field: "auditExpiry",
      type: "date",
    },
    {
      title: "Certification Status",
      field: "certificationStatus",
      sorting: false,
    },
    {
      title: "Standard",
      field: "standard",
      sorting: false,
    },
  ];

  const indexByTitle = siteColumns.findIndex(c => c.title?.trim() === "Status"); // Finding the index of the "Status" column.

  if(cbUser || brcgsUser)
    return [
      ...siteColumns.slice(0, indexByTitle), 
      // To remove the "Status" column in case of CB's and BRCGS users we have sliced from 0 -> indexByTitle i.e. before the "Status" column.
      // If we want to include the "Status" column then it should be 0, indexTitle + 1
      ...additionalSiteColumns,
      ...siteColumns.slice(indexByTitle + 1),
    ];

  return siteColumns;
}

export default SiteColumnTable;
